module.exports = __webpack_public_path__ + "static/img/yxlogo_en.606910ff.png";